<script>
  import ServerAdminChip from "../ServerAdminChip.svelte"
  import ProjectUserProjectAdminChip from "../ProjectUserProjectAdminChip.svelte"
  import ProjectUserResultInputChip from "../ProjectUserResultInputChip.svelte"
  import ProjectUserReadOnlyChip from "../ProjectUserReadOnlyChip.svelte"
  import ProjectUserDefinedByRoleChip from "../ProjectUserDefinedByRoleChip.svelte";
  import ProjectUserPlannerChip from "../ProjectUserPlannerChip.svelte";

  export let permission
</script>

{#if permission}
  {#if permission === "ServerAdmin"}
    <ServerAdminChip />
  {/if}
  {#if permission === "Planner"}
    <ProjectUserPlannerChip />
  {/if}
  {#if permission === "ProjectAdmin"}
    <ProjectUserProjectAdminChip />
  {/if}
  {#if permission === "ResultInput"}
    <ProjectUserResultInputChip />
  {/if}
  {#if permission === "ReadOnly"}
    <ProjectUserReadOnlyChip />
  {/if}
  {#if permission === "DefinedByRoles"}
    <ProjectUserDefinedByRoleChip />
  {/if}
{/if}